function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { of } from "rxjs";
import { logError } from "../actions";
export default function(error, key, originalAction) {
    var additinalProps = {};
    if (key) {
        additinalProps.key = key;
    }
    if (error.status === 401) {
        location.href = "/";
        return of({
            type: "AUTH_ERROR"
        });
    }
    return of(logError(_objectSpread({
        error: error
    }, additinalProps)));
} // 5xx --> error view: server is down, try again later, if problem persists: contact support@cbook.de
 // 504 --> server timeout, application tries to reload x times - after that, display a message to the user that the problem could not be solved automatically. try relaoding or come back later - if problem persists, contact support@cbook.de
 //
